import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, Row, Col, ModalFooter } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import "flatpickr/dist/themes/material_blue.css";
import { showInfoMessage } from "../../../../../../helpers/utils";

const CorespondentModal = props => {
  const { isOpen, toggle, userId, editData, permissions, bankDetails } = props;
  const onSubmitForm = (e, errors, params) => {
    if (errors?.length === 0) {
      let currentData = {
        ...params,
      };

      if (Object.keys(bankDetails).length === 0) {
        showInfoMessage("First you need to add a bank information");
      } else {
        if (editData !== null) {
          props.permissions["change_bankcorrespondentmodel"] &&
            props.updateBankCorespondent(editData.id, currentData, editData.user);
          toggle();
        } else {
          currentData["bank_details"] = bankDetails.id;
          currentData["user"] = bankDetails.user;
          props.permissions["add_bankcorrespondentmodel"] &&
            props.addBankCorespondent(currentData);
          toggle();
        }
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      autoFocus={true}
      centered={true}
      toggle={toggle}
      size="md"
    >
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} corespondent
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={onSubmitForm}>
        <ModalBody>
          <Row>
            <Col md={12}>
              <div className="mb-3">
                <AvField
                  name="correspondent_bank"
                  label="Correspondent bank"
                  placeholder="Correspondent bank..."
                  type="text"
                  value={editData?.correspondent_bank || ""}
                  validate={{
                    required: true,
                    minLength: {
                      value: 3,
                      errorMessage: "Min 3 words",
                    },
                  }}
                />
              </div>
            </Col>
            <Col md={12}>
              <div className="mb-3">
                <AvField
                  name="address"
                  label="Correspondent bank address"
                  placeholder="Corespondent bank address..."
                  type="text"
                  value={editData?.address || ""}
                />
              </div>
            </Col>
            <Col md={12}>
              <div className="mb-3">
                <AvField
                  name="account_in_the_correspondent_bank"
                  label="Account in the correspondent bank"
                  type="text"
                  placeholder="Account in the correspondent bank..."
                  value={editData?.account_in_the_correspondent_bank || ""}
                  validate={{
                    required: true,
                    minLength: {
                      value: 3,
                      errorMessage: "Min 3 words",
                    },
                  }}
                />
              </div>
            </Col>
            <Col md={12}>
              <div className="mb-3">
                <AvField
                  name="swift_code_of_the_correspondent_bank"
                  label="Correspondent`s bank SWIFT / BIC"
                  placeholder="Correspondent`s bank SWIFT / BIC code..."
                  type="text"
                  value={editData?.swift_code_of_the_correspondent_bank || ""}
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                {permissions["delete_bankcorrespondentmodel"] && (
                  <button
                    type="button"
                    className={`btn btn-danger save-user me-3 ${
                      editData !== null ? "" : "d-none"
                    }`}
                    onClick={() =>
                      props.onClickDelete(
                        editData.correspondent_bank,
                        editData.id,
                        bankDetails.user
                      )
                    }
                  >
                    Delete corespondent
                  </button>
                )}
                <button type="submit" className="btn btn-success save-user">
                  Save changes
                </button>
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

CorespondentModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  editData: PropTypes.object,
  data: PropTypes.any,
  permissions: PropTypes.any,
  bankDetails: PropTypes.any,
  userId: PropTypes.string.isRequired,
  updateBankCorespondent: PropTypes.func.isRequired,
  addBankCorespondent: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
};

export default CorespondentModal;
